import { useNavigate } from 'react-router-dom';
import './Home.css';

const SERVICES = [
  { icon: '⚙️', title: 'Industrial Machinery', desc: 'Premium lathe machines, drill presses, and heavy industrial equipment sourced from top manufacturers.' },
  { icon: '📄', title: 'Transparent Agreements', desc: 'Generate professional sales and lease agreements instantly with full digital signatures.' },
  { icon: '💳', title: 'Flexible Payment Plans', desc: 'Customised installment plans tailored to your business with clear monthly schedules.' },
  { icon: '✅', title: 'Verified & Trusted', desc: 'Every transaction backed by a formal signed agreement — protecting both buyer and seller.' },
];

function Home() {
  const navigate = useNavigate();

  return (
    <div className="home">

      {/* ── HERO ── */}
      <section className="home-hero">
        <div className="home-hero-bg" />
        <div className="home-hero-glow" />
        <div className="home-hero-content">
          <div className="home-hero-tag">DIBBA INDUSTRIAL AREA, UAE</div>
          <h1 className="home-hero-title">
            INDUSTRIAL<br />
            <span className="home-hero-accent">MACHINERY</span><br />
            TRADING
          </h1>
          <p className="home-hero-desc">
            Al Mushtaraka Trading Company supplies premium industrial machinery and equipment across the UAE, Oman, Qatar, Saudi Arabia, Pakistan and worldwide.
          </p>
          <div className="home-hero-actions">
            <button className="home-btn-primary" onClick={() => navigate('/hub')}>
              Operations Panel →
            </button>
            <a href="#services" className="home-btn-outline">Our Services</a>
          </div>
        </div>

        <div className="home-hero-stats">
          {[
            { number: '500+', label: 'Machines Sold' },
            { number: '10+', label: 'Years Experience' },
            { number: '200+', label: 'Happy Clients' },
            { number: 'UAE', label: 'Based & Trusted' },
          ].map((s, i) => (
            <div className="home-stat" key={i}>
              <span className="home-stat-number">{s.number}</span>
              <span className="home-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── DIVIDER ── */}
      <div className="home-section-divider" id="services">
        <span className="home-divider-line" />
        <span className="home-divider-text">WHAT WE OFFER</span>
        <span className="home-divider-line" />
      </div>

      {/* ── SERVICES ── */}
      <section className="home-services">
        <div className="home-services-grid">
          {SERVICES.map((s, i) => (
            <div className="home-service-card" key={i}>
              <div className="home-service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="home-about">
        <div className="home-about-inner">
          <div className="home-about-text">
            <p className="home-about-tag">WHO WE ARE</p>
            <h2 className="home-about-title">Built on Trust,<br />Driven by Industry</h2>
            <p className="home-about-desc">
              Al Mushtaraka Trading Company is a UAE-based industrial machinery supplier with over a decade of experience serving businesses across the Gulf and beyond. We specialise in sourcing, supplying, and financing premium industrial equipment — from lathe machines to heavy-duty drill presses — with full transparency and professional documentation.
            </p>
            <p className="home-about-desc">
              Our team is committed to building long-term partnerships with businesses in the UAE, Oman, Qatar, Saudi Arabia, Pakistan, and worldwide. Every transaction is backed by a formal signed agreement, ensuring security and clarity for both parties.
            </p>
            <div className="home-about-stats">
              <div className="home-about-stat">
                <span className="home-about-stat-num">10+</span>
                <span className="home-about-stat-lbl">Years in Business</span>
              </div>
              <div className="home-about-stat">
                <span className="home-about-stat-num">500+</span>
                <span className="home-about-stat-lbl">Machines Delivered</span>
              </div>
              <div className="home-about-stat">
                <span className="home-about-stat-num">8+</span>
                <span className="home-about-stat-lbl">Countries Served</span>
              </div>
            </div>
          </div>
          <div className="home-about-card">
            <div className="home-about-card-icon">🏭</div>
            <p className="home-about-card-name">ARIF MUKHTAR MALIK</p>
            <p className="home-about-card-role">Partner &amp; Manager</p>
            <div className="home-about-card-divider" />
            <p className="home-about-card-location">📍 Dibba Industrial Area, UAE</p>
            <p className="home-about-card-tagline">"Delivering quality machinery with complete peace of mind."</p>
          </div>
        </div>
      </section>

      {/* ── DIVIDER 2 ── */}
      <div className="home-section-divider">
        <span className="home-divider-line" />
        <span className="home-divider-text">OUR REACH</span>
        <span className="home-divider-line" />
      </div>

      {/* ── COUNTRIES STRIP ── */}
      <div className="home-countries-strip">
        {[
          '🇵🇰 Pakistan',
          '🇦🇪 UAE',
          '🇰🇷 South Korea',
          '🇨🇳 China',
          '🇴🇲 Oman',
          '🇶🇦 Qatar',
          '🇧🇭 Bahrain',
          '🇸🇦 Saudi Arabia',
        ].map((c, i) => (
          <div className="home-country-item" key={i}>{c}</div>
        ))}
      </div>

      {/* ── CTA BANNER ── */}
      <section className="home-cta-banner">
        <div className="home-cta-glow" />
        <div className="home-cta-content">
          <p className="home-cta-tag">FOR AUTHORISED PERSONNEL</p>
          <h2>ACCESS THE OPERATIONS PANEL</h2>
          <p>Manage agreements, customers, and employees from one secure platform.</p>
          <button className="home-btn-primary" onClick={() => navigate('/hub')}>
            Enter Operations Panel →
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="home-footer">
        <div className="home-footer-inner">
          <div className="home-footer-brand">
            <span className="brand-main">AL MUSHTARAKA</span>
            <span className="brand-sub">TRADING COMPANY</span>
          </div>
          <div className="home-footer-info">
            <p>📍 Dibba Industrial Area, UAE</p>
            <p>👤 Arif Mukhtar Malik — Partner &amp; Manager</p>
          </div>
          <p className="home-footer-copy">© {new Date().getFullYear()} Al Mushtaraka Trading Company. All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
}

export default Home;
